import { Button } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExploreLanguageSwitch } from "./ExploreLanguageSwitch";

type ExploreHeaderProps = {
  signupUrl: string;
  browsePath: string;
};

export function ExploreHeader({ signupUrl }: ExploreHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className="explore-header">
      <Link to="/explore" className="explore-header-brand">
        <img src="/favicon.ico" alt="Bomani" />
        <span className="explore-header-brand-name">Bomani</span>
      </Link>
      <div className="explore-header-actions">
        <ExploreLanguageSwitch />
        <Link to={signupUrl}>
          <Button type="primary">{t("Explore_Start_Free")}</Button>
        </Link>
      </div>
    </header>
  );
}
